import {Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {Alerts, DialogButton} from '../../lib/alerts';

@Component({
    selector: 'app-test-dialogs',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [],
    templateUrl: './test-dialogs.component.html',
    styleUrl: './test-dialogs.component.scss'
})
export class TestDialogsComponent {

    async onShowAlert() {
        const btn = await Alerts.alertPopup({ body: 'This is a test alert dialog.' });
        console.log('Alert dialog closed with button:', btn);
    }

    async onShowError() {
        const btn = await Alerts.alertPopup({ body: 'This is a test error dialog.', header: 'Severe <i>Error!', error: true });
        console.log('Error dialog closed with button:', btn);
    }

    async onShowYesNo() {
        const btn = await Alerts.alertPopup({
            body: 'Would you like strawberries?',
            header: 'Your Choice',
            buttons: [DialogButton.Yes, DialogButton.No]
        });
        console.log('Error dialog closed with button:', btn);
    }

    async onShareLink() {
        await Alerts.alertShareLink({
            title: 'my precious web page',
            header: 'Share Link',
            link: '/aslkjdfh/asdfhasdf'
        });
    }

    async onShowPrompt() {
        const text = await Alerts.alertPrompt({ body: 'Your name please: ', header: 'Prompt Dialog' });
        console.log('Prompt dialog returned text:', text);
    }

    async onShowProgress() {
        const popup = Alerts.showProgressDialog('This is a test progress dialog.');
        setTimeout(() => popup.hide(), 2_000)
    }
}
